import _Object$defineProperties from '/var/www/html/node_modules/babel-runtime/core-js/object/define-properties';
import axios from 'axios';
require('~/plugins/session-local-storage.js');
export default function (Vue) {
    Vue.auth = {
        setToken: function setToken(access_token, refresh_token, token_type, expires_in) {
            if (access_token && token_type && expires_in) {
                //                localStorage.setItem('token', access_token);
                //                localStorage.setItem('refresh_token', refresh_token);
                //                localStorage.setItem('token_type', token_type);
                //                localStorage.setItem('expires_in', Date.now() + (expires_in * 1000));                

                customLocalStorage.setItem('token', access_token);
                customLocalStorage.setItem('refresh_token', refresh_token);
                customLocalStorage.setItem('token_type', token_type);
                customLocalStorage.setItem('expires_in', Date.now() + expires_in * 1000);

                this.setAuthorizationHeaders();
            }
        },
        setAuthorizationHeaders: function setAuthorizationHeaders() {
            axios.defaults.headers.common['Authorization'] = this.getHeaders();
        },
        login: function login(username, password, successCallBack, errorCallback) {
            var _this = this;

            var data = {
                grant_type: 'password',
                client_id: process.env.oAuthClientId,
                client_secret: process.env.oAuthClientSecret,
                username: username,
                password: password,
                scope: null
            };

            axios.post(global.websiteSettings.extra_info.api_endpoint + 'oauth/token', data).then(function (res) {
                _this.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                if (successCallBack) {
                    successCallBack();
                }
            }).catch(function (err) {
                if (errorCallback) {
                    errorCallback(err);
                } else {
                    console.log(err);
                }
            });
        },
        getUser: function getUser(setCallback) {
            if (!this.isAuthenticated()) {
                this.destroyToken();
                if (setCallback) {
                    setCallback(null);
                }
                return null;
            }

            var user = {
                name: ''
            };

            axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/user').then(function (response) {
                user = response.data;
                //                localStorage.setItem('user', JSON.stringify(user));
                //                customLocalStorage.setItem('user', JSON.stringify(user));
                if (setCallback) {
                    setCallback(user);
                }
            });
        },
        getToken: function getToken() {
            //            let token = localStorage.getItem('token');
            //            let expires_in = localStorage.getItem('expires_in');
            var token = customLocalStorage.getItem('token');
            var expires_in = customLocalStorage.getItem('expires_in');

            if (token === "undefined") {
                this.destroyToken();
                return null;
            }

            if (!token || !expires_in) {
                this.destroyToken();
                return null;
            }

            if (Date.now() > parseInt(expires_in)) {
                this.destroyToken();
                return null;
            }

            return token;
        },
        getTokenType: function getTokenType() {
            //            return localStorage.getItem('token_type');
            return customLocalStorage.getItem('token_type');
        },
        destroyToken: function destroyToken() {
            //            localStorage.removeItem('token');
            //            localStorage.removeItem('refresh_token');
            //            localStorage.removeItem('token_type');
            //            localStorage.removeItem('expires_in');
            //            localStorage.removeItem('user');
            //            localStorage.clear();
            customLocalStorage.removeItem('token');
            customLocalStorage.removeItem('refresh_token');
            customLocalStorage.removeItem('token_type');
            customLocalStorage.removeItem('expires_in');
            //            customLocalStorage.removeItem('user');
            customLocalStorage.clear();
        },
        isAuthenticated: function isAuthenticated() {
            // TODO check isTokenExpired
            if (this.getToken()) {
                return true;
            } else {
                return false;
            }
        },
        getHeaders: function getHeaders() {
            return this.getTokenType() + ' ' + this.getToken();
        }
    };

    _Object$defineProperties(Vue.prototype, {
        $auth: {
            get: function get() {
                return Vue.auth;
            }
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./plugins/auth.js
// module id = ./plugins/auth.js
// module chunks = 54